import { supabase, TABLES } from '../supabase/supabase';

const delay = (ms) => new Promise(res => setTimeout(res, ms));

export const authService = {
  /**
   * Complete Signup Flow:
   * 1. Auth SignUp (Trigger creates user_profile in DB)
   * 2. Poll for profile existence (Ensures DB consistency)
   * 3. Invoke 'create_organization' Edge Function (Handles Org + Membership)
   */
  async signUp(email, password, fullName, orgName) {
    console.log("Starting signup flow for:", email);

    try {
      // 1. Sign up user via Auth
      // The database trigger will automatically create the profile record
      const { data: authData, error: authError } = await supabase.auth.signUp({
        email,
        password,
        options: { 
          data: { full_name: fullName }
        }
      });

      if (authError) {
        console.error("Auth Signup Error:", authError);
        throw authError;
      }
      
      if (!authData.user) {
        throw new Error('Signup failed - no user returned from Auth');
      }

      const userId = authData.user.id;
      console.log('Auth signup success, user id:', userId);

      // 2. Poll to confirm profile exists
      // We do not insert here. We only wait for the trigger to finish.
      let profileFound = false;
      for (let i = 0; i < 5; i++) {
        console.log(`Polling for profile... (Attempt ${i + 1}/5)`);
        const { data: profile } = await supabase
          .from(TABLES.USER_PROFILES)
          .select('id')
          .eq('id', userId)
          .maybeSingle();

        if (profile) {
          profileFound = true;
          console.log("Profile confirmed in database.");
          break;
        }
        await delay(1000); // Wait 1s between polls
      }

      if (!profileFound) {
        console.warn("Profile not found after polling, proceeding to org creation anyway...");
      }

      // 3. Call Edge Function to handle Org and Membership creation
      // IMPORTANT: Using 'create_organization' with underscore
      console.log('Invoking create_organization for:', orgName);
      const { data, error: fnError } = await supabase.functions.invoke('create_organization', {
        body: { orgName, userId }
      });

      if (fnError) {
        console.error("Edge Function Invocation Error:", fnError);
        throw new Error(`Workspace creation failed: ${fnError.message}`);
      }

      if (data && data.success === false) {
        console.error("Edge Function Business Logic Error:", data.error);
        throw new Error(`Workspace creation failed: ${data.error}`);
      }

      console.log("Signup flow completed successfully.");
      return { user: authData.user, orgId: data?.orgId };

    } catch (err) {
      console.error("CRITICAL SIGNUP ERROR:", err);
      throw err;
    }
  },

  async login(email, password) {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    if (error) throw error;
    return data;
  }
};